import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { environment } from 'src/environments/environment';
import { BaseService } from '../shared/services/base.service';
import { TranslationService } from '../shared/i18n/translation.service';
import { News } from '../models/news.model';

@Injectable({
    providedIn: 'root',
})
export class NewsService extends BaseService<News> {

    httpOptions = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json',
        }),
    };
    langId: number = 1;
    API_URL = `${environment.apiUrl}/news`;
    API_URLFind = `${environment.apiUrl}/news/Find`;
    API_URLGetAll = `${environment.apiUrl}/news`;
    API_URLAdd = `${environment.apiUrl}/news`;
    API_URLUpdate = `${environment.apiUrl}/news`;
    API_URLDelete = `${environment.apiUrl}/news`;
    API_URLGetById = `${environment.apiUrl}/news`;
    constructor(@Inject(HttpClient) http: HttpClient, public toastr: ToastrService, public translationServices: TranslationService) {
        super(http, toastr, translationServices);
    }


}
